export const navItems = {
  PETS: {
    label: "PETS",
    items: ["Dogs", "Cats", "Birds", "Fish"],
  },
  FARMS: {
    label: "FARMS",
    items: ["Livestock", "Equipment", "Feed"],
  },
  EXOTICS: {
    label: "EXOTICS",
    items: ["Reptiles", "Amphibians", "Small Pets"],
  },
  SHOP: {
    label: "SHOP",
    items: ["Food", "Supplies", "Accessories"],
  },
} as const;
